<template>
  <InvoicesTable :columns="filteredColumns" :data="tableData" :isLoading="isLoading" :hasEmptyTable="hasEmptyTable" />
</template>
<script setup>
import InvoicesTable from '@/components/billing/invoices/InvoicesTable.vue'
import { useIsMobile } from '@/composables/useIsMobile'
import { computed } from 'vue'

const props = defineProps({
  invoices: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  hasEmptyTable: {
    type: Boolean,
    default: false,
  },
  accommodationsData: {
    type: Array,
    default: () => [],
  },
})

const { isMobile } = useIsMobile()
const getPropertyName = itemId => {
  return props.accommodationsData.find(item => {
    return item.accommodationId === itemId
  })?.name
}
const tableData = computed(() => {
  if (props.hasEmptyTable) {
    return [...Array(6).keys()].map(i => ({
      invoiceId: i,
      invoiceDate: '',
      dueDate: '',
      property: '',
      productType: '',
      amount: '',
      status: '',
      download: '',
    }))
  } else {
    return props.invoices.map(item => {
      return {
        ...item,
        property: getPropertyName(item.accommodationId),
      }
    })
  }
})

const columns = [
  {
    id: 'invoiceNumber',
    header: 'tbs_invoice',
    colType: 'string',
    sortable: true,
    className: 'col-invoiceNumber',
    isMobile: true,
  },
  {
    id: 'invoiceDate',
    header: 'tbs_invoice_date',
    colType: 'date',
    sortable: true,
    className: 'col-invoiceData',
    isMobile: true,
  },
  {
    id: 'dueDate',
    header: 'tbs_invoice_due_date',
    colType: 'date',
    sortable: true,
    className: 'col-dueDate',
    isMobile: true,
  },
  {
    id: 'property',
    header: 'tbs_property_filter',
    colType: 'string',
    sortable: true,
    className: 'col-property',
    isMobile: true,
  },
  {
    id: 'productType',
    header: 'tbs_product_filter',
    colType: 'string',
    sortable: true,
    className: 'col-productType',
    isMobile: true,
  },
  {
    id: 'amount',
    header: 'tbs_invoice_amount',
    colType: 'currency',
    sortable: true,
    className: 'col-amount',
    isMobile: true,
  },
  {
    id: 'status',
    header: 'tbs_invoice_status',
    colType: 'string',
    sortable: true,
    className: 'col-status',
    isMobile: false,
  },
  {
    id: 'download',
    header: 'tbs_invoice_file',
    colType: 'download',
    sortable: false,
    className: 'col-download',
    isMobile: false,
  },
]

const filteredColumns = computed(() => {
  if (isMobile.value) return columns.filter(item => item.isMobile)
  if (props.accommodationsData.length === 1) return columns.filter(item => item.id !== 'property')
  else return columns
})
</script>
